const styles = (theme) => ({
  buttonRoot: {
    height: 39,
    width: 39,
    borderRadius: theme.shape.borderRadius,
    color: '#A9B0B8',
    fill: 'currentColor',
  },
});

export default styles;
